import React from 'react';
import ContactForm from '../ContactFrom/ContactForm';

const Contactpage = () => {
    return (
        <section className="wpo-contact-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-10 offset-lg-1">
                        <div className="office-info">
                            <div className="row">
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-placeholder"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Address</h2>
                                            <p>14455 Richmond Highway</p>
                                            <p>Woodbridge, VA 22191</p>
                                            <p>Suite #4</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-email"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Email Us</h2>
                                            <p>gullate45@gmail.com</p>
                                            <p>For catering inquiries</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-phone-call"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Call Now</h2>
                                            <p>571 331 2344</p>
                                            <p>571 408 4956</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wpo-contact-title">
                            <h2>Have Any Questions?</h2>
                            <p>Contact us for authentic Ethiopian catering, fresh injera, quality spices, money transfer services, or household needs. We're happy to help!</p>
                        </div>
                        <div className="wpo-contact-form-area">
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
            <section className="wpo-contact-map-section">
                <div className="wpo-contact-map">
                    <iframe 
                        title='contact-map' 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3109.082729447745!2d-77.26320392421873!3d38.79789797172715!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b64e1e0f4d7f89%3A0x7e1e1e1e1e1e1e1e!2s4455%20Richmond%20Hwy%2C%20Woodbridge%2C%20VA%2022191!5e0!3m2!1sen!2sus!4v1620000000000!5m2!1sen!2sus" 
                        allowFullScreen="" 
                        loading="lazy">
                    </iframe>
                </div>
            </section>
        </section>
    )
}

export default Contactpage;